/*
 * Created on Sat Mar 23 2017
 *
 * Copyright (c) 2019 Sébastien Hecart - Fahbe Mobile App
 */
export default {
  cgu: {
    titre: '⚠️ AVERTISSEMENT IMPORTANT — CGU v3.0',
    popup_intro:
      "BatiKal est un outil numérique d'aide au calcul fourni exclusivement à des fins pédagogiques, d'apprentissage, d'exercice, de simulation et d'information générale.",
    popup_results_intro: 'Les Résultats générés par l’Application :',
    popup_results_1: 'sont produits automatiquement à partir de modèles simplifiés et sont purement indicatifs ;',
    popup_results_2:
      "ne constituent ni une étude technique opposable, ni une note de calcul réglementaire, ni un avis professionnel ;",
    popup_results_3: "ne remplacent en aucun cas un bureau d'études, un ingénieur, un architecte ou un contrôleur technique ;",
    popup_results_4:
      'ne doivent jamais être utilisés comme unique base de décision dans un projet réel sans validation préalable par un professionnel qualifié et assuré.',
    popup_validation:
      "Toute utilisation des Résultats dans un contexte réel (chantier, ouvrage, dossier réglementaire, marché) doit obligatoirement faire l'objet d'une validation préalable par un professionnel qualifié et assuré.",
    popup_responsibility:
      "L'utilisation de l'Application s'effectue sous la seule responsabilité de l'Utilisateur, qui demeure seul responsable de ses obligations professionnelles, de l'interprétation des Résultats et des décisions prises.",
    popup_liability_intro:
      "Dans les limites permises par la loi, et sauf dol, faute lourde, dommage corporel imputable à l'Éditeur ou garanties légales des consommateurs (CGU art. 10.4), la responsabilité de BatiKal ne peut être engagée notamment en cas de :",
    popup_liability_1: "erreurs ou imprécisions de calcul liées aux modèles simplifiés ;",
    popup_liability_2: 'défauts de conception ou de dimensionnement d’un ouvrage réel ;',
    popup_liability_3: 'malfaçons, non-conformités réglementaires ou défauts d’exécution ;',
    popup_liability_4: 'dommages matériels affectant un ouvrage ou ses équipements ;',
    popup_liability_5: 'sinistres, désordres ou pertes d’exploitation ;',
    popup_liability_6: "effondrement, ruine ou détérioration d'un ouvrage ;",
    popup_liability_7:
      "usage des Résultats sans validation par un professionnel qualifié, ou présentation des Résultats comme validés par l'Éditeur.",
    popup_accept_intro: "En activant « J'accepte », vous reconnaissez :",
    popup_accept_1: "avoir lu et compris les Conditions Générales d'Utilisation et la Politique de confidentialité ;",
    popup_accept_2: "comprendre la nature pédagogique et les limites techniques de l'Application ;",
    popup_accept_3:
      'accepter les limitations de responsabilité de l’Éditeur, dans les limites autorisées par la loi française et européenne impérative ;',
    popup_accept_4:
      "utiliser l'Application en connaissance de cause, à des fins d'exercice et de simulation, et faire valider tout usage en contexte réel par un professionnel qualifié.",
    message2:
      "Vous pouvez consulter les CGU et la politique de confidentialité à tout moment dans l'onglet Profil, et retirer votre consentement (ce qui mettra fin à votre accès au service). Ce consentement est requis pour utiliser BatiKal. En cas de refus, vous devez cesser immédiatement d'utiliser l'Application.",
    access:
      'Consulter les https://app.batikal-app.com/cgu et la https://app.batikal-app.com/privacy de BatiKal',
    acceptLabel: "J'accepte les CGU v3.0 et la politique de confidentialité"
  },
  settingsProfile_conditionConfi: 'Conditions et confidentialités',
  settingsProfile_delete: 'Supprimer votre compte',
  mentionlegalcontent:
    "BatiKal est un outil d'exercice et de simulation. Les résultats sont indicatifs et doivent être validés par un professionnel qualifié avant toute utilisation sur un projet réel. Voir les CGU complètes dans l'application.",
  mentionlegalcontentShort:
    "Ce calcul est fourni à titre informatif et d'exercice. BatiKal ne garantit pas l'exactitude des résultats. Faire vérifier par un professionnel qualifié avant toute utilisation sur un projet réel.\n"
}
